export const LIGHT = {
  1: { label: "In produzione", color: "#22c55e" },
  3: { label: "Avviso", color: "#eab308" },
  2: { label: "Guasto", color: "#ef4444" },
  4: { label: "Offline", color: "#737373" },
};
export const DIREZ = "torri_direzionale";
export const DIREZ_NAME = "Divisione Impianti Torri";
export const nf = (n, d = 1) => (n ?? 0).toLocaleString("it-IT", { maximumFractionDigits: d });
export const kw = (w) => (w >= 1000 ? `${nf(w / 1000, 2)} kW` : `${nf(w, 0)} W`);
export const ago = (iso) => {
  if (!iso) return "—";
  const m = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  if (m < 60) return `${m} min fa`;
  if (m < 1440) return `${Math.round(m / 60)} h fa`;
  return `${Math.round(m / 1440)} gg fa`;
};
export const dtt = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
